import { DISCARDED, SKIPPED } from '@openobserve/browser-core';
export function startTrackingConsentContext(hooks, trackingConsentState) {
    function isConsented() {
        const wasConsented = trackingConsentState.isGranted();
        if (!wasConsented) {
            return DISCARDED;
        }
        return SKIPPED;
    }
    hooks.register(0 /* HookNames.Assemble */, isConsented);
    hooks.register(1 /* HookNames.AssembleTelemetry */, isConsented);
}
//# sourceMappingURL=trackingConsentContext.js.map